<template>
    <div class="all_ynjc">
        <div class="main_ynjc">
            <!--头部-->
            <header1></header1>
            <!--导航-->
            <navigation></navigation>
            <div class="position_ynjc">您所在的位置：<router-link  :to="{ path: '/'}">首&nbsp;页</router-link><span>&gt;&gt;</span>资讯详情</div>
            <!--政策法规/下载专区-->
            <div class="erji_ynjc">
                <div class="infoBox_ynjc">
                    <div class="notices_main_ynjc">
                        <div class="detailInfo_ynjc">
                            <div class="detailInfo_title_ynjc">{{newsInfo.newsTitle}}</div>
                            <div class="detailInfo_main_ynjc">
                                <div v-html="newsInfo.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--版权-->
            <footer1></footer1>
        </div>
    </div>
</template>

<script>
    import {getNews} from '../api/api';
    import  navigation from '../components/Navigation';
    import  header1 from '../components/Header1';
    import  footer1 from '../components/Footer1';
    export default {
        components: {
            header1,
            footer1,
            navigation
        },
        data () {
            return {
                newsInfo: {}
            }
        },
        mounted () {
            getNews({
                id: this.$route.query.id
            }).then((response) => {
                this.newsInfo = response.data.data.newsInfo;
                //document.title="资讯详情-"+this.newsInfo.newsTitle
            })
        },
        computed: {},
        methods: {}
    }
</script>